module.exports = __webpack_public_path__ + "img/t1_i_one.8001d3d6.png";